export enum ActivityGroupStatus {
	planned = 'planned',
	inProgress = 'inProgress',
	delayed = 'delayed',
	complete = 'complete',
	overdue = 'overdue',
	deleted = 'deleted',
}
